import { defineComponent as _defineComponent } from 'vue';
import FacebookSSO from '~/components/common/icons/FacebookSSO.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BFacebookSignIn',
  emits: ['login-success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    /* global FB */

    var config = useRuntimeConfig();
    var notifier = useNotifier();
    function loadFacebookSDK() {
      window.fbAsyncInit = function () {
        FB.init({
          appId: config.facebookSSOClientID,
          cookie: true,
          xfbml: true,
          version: 'v19.0'
        });
        FB.AppEvents.logPageView();
      };

      // Load the SDK asynchronously
      (function (d, s, id) {
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        var js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
    function loginWithFacebook() {
      FB.login(function (response) {
        if (response.authResponse) {
          var _response$authRespons;
          emit('login-success', response === null || response === void 0 ? void 0 : (_response$authRespons = response.authResponse) === null || _response$authRespons === void 0 ? void 0 : _response$authRespons.accessToken);
        } else {
          notifier.showMessage({
            content: 'User cancelled login or did not fully authorize.',
            type: 'error'
          });
        }
      }, {
        scope: 'email,public_profile'
      });
    }
    onMounted(function () {
      loadFacebookSDK();
    });
    return {
      __sfc: true,
      emit: emit,
      config: config,
      notifier: notifier,
      loadFacebookSDK: loadFacebookSDK,
      loginWithFacebook: loginWithFacebook,
      FacebookSSO: FacebookSSO
    };
  }
});